import React from 'react';

// helpers
import useTranslation from '../../../../../hooks/useTranslation';
import ErrorHandlerService, {
  ErrorFromServer,
} from 'services/error-handler/service';
import { FormikHelpers } from 'formik';
import { GetAuthenticatorConfigResponse } from '../../../../../api/profile/securityAPI';
import { Enable2FAuthenticatorValidationSchema } from '../../../../../validations/profile/security';

// components
import InnerForm from './InnerForm';
import LoadingWrapper from '../../../../WrapperComponents/LoadingWrapper';
import Form, { RequiredPropsForFormModel } from '@core_components/Form';
import ModalDialog, {
  RequiredPropsForModalDialogModel,
} from '@core_components/ModalDialog';

interface IProps
  extends RequiredPropsForModalDialogModel,
    RequiredPropsForFormModel<FormValuesModel> {
  responseData: {
    data: GetAuthenticatorConfigResponse | null;
    loading: boolean;
  };
}

export interface FormValuesModel {
  code: string | null;
}

const EnableAuthenticatorModal = ({
  isVisible,
  closeCallback,
  onSubmit,
  initialValues,
  responseData,
}: IProps) => {
  const { t } = useTranslation(['profile', 'custom_errors']);

  const handleOnSubmitError = (
    error: ErrorFromServer,
    _: FormValuesModel,
    formikHelpers: FormikHelpers<FormValuesModel>,
  ) => {
    const errorCode = ErrorHandlerService.getErrorCodeFromError(error);

    switch (errorCode) {
      case '1201014': {
        formikHelpers.setFieldError(
          'code',
          t('1201014', { ns: 'server_errors' }),
        );
        break;
      }
      default: {
        ErrorHandlerService.handleError(error);
        break;
      }
    }
  };

  return (
    <Form<FormValuesModel>
      enableReinitialize
      onSubmit={onSubmit}
      onSubmitError={handleOnSubmitError}
      initialValues={isVisible ? initialValues : null}
      validationSchema={Enable2FAuthenticatorValidationSchema}
      renderForm={
        <ModalDialog
          width={650}
          title={t(
            'security.two_step_verification.authenticator.enable_authenticator.title',
          )}
          isVisible={isVisible}
          closeCallback={closeCallback}
          submitButtonProps={{
            text: t('security.two_step_verification.enable_button'),
          }}
          closeModalAfterError={false}
        >
          <LoadingWrapper loading={responseData.loading}>
            {responseData.data ? (
              <InnerForm responseData={responseData.data} />
            ) : null}
          </LoadingWrapper>
        </ModalDialog>
      }
    />
  );
};

export default EnableAuthenticatorModal;
